import { useEffect, useState } from 'react'
import i18n, { i18n as I18nInstance } from 'i18next'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import clsx from 'clsx'
import { TravelSearchSkeleton } from './Components/Shared/TravelSearchSkeleton'
import { TravelSearchOfferSkeleton } from './Components/Shared/TravelSearchOfferSkeleton'
import TravelSearch from './Components/TravelSearch'
import { getBaseApi, getLocaleFromUrlOrQuery } from './Utils'
import { fetcher } from './Utils/fetcher'
import { useTravelSearchConfig } from './Hooks/useTravelSearchConfig'

const baseApi = getBaseApi()
const locale = getLocaleFromUrlOrQuery()

interface Props {
  hasOffer?: boolean
}

export default function AppWithContent({ hasOffer }: Props) {
  const [ready, setReady] = useState(false)
  const [content, setContent] = useState<any>(null)
  const [i18Instance, setI18Instance] = useState<I18nInstance | null>(null)
  const travelSearchConfig = useTravelSearchConfig()
  const [errorMessage, setErrorMessage] = useState<string>('')
  useEffect(() => {
    let canceled = false
    const url = `${baseApi}/content?locale=${locale}`

    fetcher<{ content: any }>(url)
      .then((res) => {
        if (!canceled) {
          setContent(res.content)
        }
      })
      .catch(() => {
        return
      })

    return () => {
      canceled = true
    }
  }, [])

  useEffect(() => {
    if (!content) return
    const instance = i18n.createInstance()
    instance
      .use(initReactI18next)
      .init({
        debug: false,
        lng: locale,
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
        resources: {},
      })
      .then(() => {
        instance.addResourceBundle(locale.substring(0, 2), 'translation', content)
        setI18Instance(instance)
      })
      .catch(() => {
        return
      })
  }, [content])

  useEffect(() => {
    if (!travelSearchConfig.isLoading) {
      if (travelSearchConfig.isMultiOffer !== undefined) {
        setReady(true)
      } else {
        if (window.location.hostname !== 'www.dfds.com') {
          setErrorMessage(`AvailableMinibooks: ${travelSearchConfig.availableMinibooks}, isMultiOffer: ${travelSearchConfig.isMultiOffer}`)
        }
        setReady(true)
      }
    }
  }, [travelSearchConfig])

  const showSkeleton = !ready || !i18Instance
  return (
    <div id="travel-search">
      <div className={clsx(showSkeleton ? 'ts-block' : 'ts-hidden')}>
        {hasOffer ? <TravelSearchOfferSkeleton /> : <TravelSearchSkeleton />}
      </div>

      {i18Instance && (
        <I18nextProvider i18n={i18Instance}>
          <div className={clsx(!showSkeleton ? 'ts-block' : 'ts-hidden')}>
            <TravelSearch errorMessage={errorMessage} travelSearchConfigResult={travelSearchConfig} />
          </div>
        </I18nextProvider>
      )}
    </div>
  )
}
